import { MomentTime } from "app/components/Moment/Moment";
import { SessionHelper } from "app/helpers/sessionHelper";
import EventPhase from "app/screens/EventsScreen/components/EventPhase/EventPhase";
import type { EventIncidentType, EventType } from "app/types/eventType";
import { BoxingPhaseTypes } from "app/utils/const";
import React, { ClassType, Component } from "react";
import { injectIntl } from "react-intl";
import "./BoxingPhase.scss";

type Props = {
  eventData: EventType;
  intl: ClassType<Props, any, any>;
};

class BoxingPhase extends Component<Props> {
  parseEventPhase(eventPhase: string) {
    const { intl } = this.props;

    if (eventPhase === BoxingPhaseTypes["PRE-MATCH"]) {
      return (
        <div className="boxing-phase__info">
          <span>
            {intl.formatMessage({
              id: "events-dashboard-pre-match",
            })}
          </span>
        </div>
      );
    } else if (eventPhase === BoxingPhaseTypes["PRE-MATCH"]) {
      return (
        <div className="boxing-phase__info">
          <span>
            {intl.formatMessage({
              id: "events-dashboard-pre-match",
            })}
          </span>
        </div>
      );
    } else if (eventPhase.indexOf("ROUND") > -1) {
      const inningStrings: string[] = eventPhase.split("_");
      const number: string = inningStrings[1];
      return (
        <div className="boxing-phase__info">
          {`${intl.formatMessage({
            id: `boxing-phase-round`,
          })} ${number}`}
        </div>
      );
    } else {
      return <div className="boxing-phase__info"></div>;
    }
  }
  render() {
    const { eventData } = this.props;
    const eventIncidents: EventIncidentType[] = eventData["eventIncidents"];
    const eventPhase: string = eventIncidents[0]["eventPhase"];
    const time: string = eventIncidents[0]["occurred-time"];
    const isRoundPhase: boolean =
      eventPhase.indexOf("ROUND") > -1 ||
      eventPhase === BoxingPhaseTypes["PRE-MATCH"] ||
      eventPhase === BoxingPhaseTypes["POST-MATCH"];
    return isRoundPhase ? (
      <div className="boxing-phase">
        {this.parseEventPhase(eventPhase)}
        <div
          className={`boxing-phase__time ${
            SessionHelper.isAsianRouteAndSessionView() &&
            "boxing-phase__time--asian"
          }`}
        >
          {time}
        </div>
      </div>
    ) : (
      <React.Fragment>
        <EventPhase eventIncident={eventIncidents[0]} />
        <MomentTime
          value={eventIncidents[0]["phaseStartDate"]}
          eventPhase={eventPhase}
          countDown
        />
      </React.Fragment>
    );
  }
}
export default injectIntl(BoxingPhase);
